import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=4c2f0e27&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=4c2f0e27&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2f0e27",
  null
  
)

export default component.exports